<template>
  <div>
    <filters v-model="suppliesFilters" @input="submitSearch" />
    <catalog-table
      id="supplies-validation-table"
      :table-data="supplies"
      :table-headers="suppliesHeaders"
      :pagination-info="paginationInfo"
      search-placeholder="Buscar por Nombre o Código"
      :pageSize="25"
      dummy-search
      @updatedSearchQuery="searchQuery = $event"
      @pageUpdated="paginationParams.currentPage = $event"
      @updatedPageSize="paginationParams.currentPageSize = $event"
    >
      <supply-validator
        slot="areValidation-cell"
        slot-scope="{ item, value }"
        role="are"
        :value="value"
        :supply="item"
        @supplyValidated="validateSupply('are', item)"
      />
      <supply-validator
        slot="purchaseValidation-cell"
        slot-scope="{ item, value }"
        role="purchase"
        :value="value"
        :supply="item"
        @supplyValidated="validateSupply('purchase', item)"
      />
    </catalog-table>
  </div>
</template>

<script>
// COMPONENT
import Filters from "./Filter";
import SupplyValidator from "./SupplyValidator";
import { CatalogTable } from "@/components/";

// SERVICES
import catalogService from "@/services/catalog";

// UTILS
import { debounce } from "lodash";

const validation_values = [false, true, null];

const DEFAULT_PARAMS = {
  family: 0,
  subfamily: 0,
  areValidation: 2,
  purchaseValidation: 2,
};

export default {
  name: "SuppliesValidationIndex",

  components: {
    CatalogTable,
    Filters,
    SupplyValidator,
  },

  data() {
    return {
      supplies: [],
      suppliesHeaders: {
        family: "Familia",
        subfamily: "Subfamilia",
        code: "Código",
        name: "Nombre",
        unitMeasurement: "Unidad de medida",
        purchaseValidation: "Aprobación Compras",
        areValidation: "Aprobación ARe",
      },
      suppliesFilters: DEFAULT_PARAMS,
      paginationParams: {
        currentPage: 1,
        currentPageSize: 10,
      },
      searchQuery: null,
      paginationInfo: null,
    };
  },

  mounted() {
    this.fetchSupplies();
  },

  methods: {
    submitSearch() {
      this.paginationParams.currentPage = 1;
      this.fetchSupplies();
    },
    fetchSupplies() {
      const {
        areValidation,
        purchaseValidation,
        family,
        subfamily,
        currentPage,
        currentPageSize,
        searchQuery,
      } = this.fetchParams;
      catalogService
        .fetch("services/suppliesvalidation", {
          paginated: true,
          config: {
            params: {
              are_validation:
                areValidation !== null ? areValidation : undefined,
              p_validation:
                purchaseValidation !== null ? purchaseValidation : undefined,
              family,
              subfamily,
              page: currentPage,
              size: currentPageSize,
              text: searchQuery,
            },
          },
        })
        .then(({ results, paginationInfo }) => {
          this.supplies = results;
          this.paginationInfo = paginationInfo;
        })
        .catch(this.$fireErrorResponse);
    },

    validateSupply(role, supply) {
      const prefix = role == "purchase" ? "p" : role;

      const key = `${role}_validation`;
      const payload = {
        id: supply.id,
        [key]: true,
      };

      supply[key] = true;

      const index = this.supplies.indexOf(supply);

      catalogService
        .update("services/suppliesvalidation", payload)
        .then((newSupply) => {
          this.$successMessage({ title: "Insumo aprobado" });
          this.supplies.splice(index, 1, newSupply);
        })
        .catch((err) => {
          this.$fireErrorResponse(err);
          supply[key] = false;
        });
    },
  },

  computed: {
    fetchParams() {
      const { paginationParams, searchQuery } = this;
      const { family, subfamily, areValidation, purchaseValidation } =
        this.suppliesFilters;

      return {
        ...paginationParams,
        searchQuery,
        family: family === 0 ? null : family,
        subfamily: subfamily === 0 ? null : subfamily,
        areValidation: validation_values[areValidation],
        purchaseValidation: validation_values[purchaseValidation],
      };
    },
  },

  watch: {
    paginationParams: {
      deep: true,
      handler() {
        this.fetchSupplies();
      },
    },
    searchQuery: debounce(function () {
      this.paginationParams.currentPage = 1;
      this.fetchSupplies();
    }, 500),
  },
};
</script>

<style lang="css" scoped>
#supplies-validation-table .md-table-cell:nth-child(4),
#supplies-validation-table .md-table-head:nth-child(4) {
  width: 45%;
}
</style>



// WEBPACK FOOTER //
// src/pages/Catalogs/Supplies/Validation/index.vue